import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner, Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";
import { FaEdit, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import IkanKelompok from "../../utilities/IkanKelompok";

const MasterIkan = () => {
    const columns = [
        {
            name: 'ID IKAN',
            cell: row => row['idIkan'],
            grow: 0.1
        },
        {
            name: 'Nama Dagang',
            cell: row => row['nmDagang']
        },
        {
            name: 'Nama Umum',
            cell: row => row['nmUmum']
        },
        {
            name: 'Nama Latin',
            cell: row => row['nmLatin']
        },
        {
            name: 'Kelompok Ikan',
            cell: row => <IkanKelompok id={row['idKelIkan']} />
        },
        {
            name: 'Satuan',
            cell: row => <>{row['kdSatuan']} - {row['uraianSatuan']}</>
        },
        {
            name: 'HS Code',
            cell: row => row['hscode']
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    {
                        localStorage.getItem("kodeTrader") !== null &&
                        <div className="row">
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah Ikan</Tooltip>}>

                                    <Button size="sm" variant="warning" onClick={() => handleClickEditIkan(row)}>
                                        <FaEdit />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    }
                </>
            )
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])
    let navigate = useNavigate()

    const [listMasterIkan, setListMasterIkan] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistMasterIkan = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listMasterIkanTrader(localStorage.getItem('kodeTrader') !== null ? localStorage.getItem('kodeTrader') : null, null, page, size)
            setListMasterIkan(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setListMasterIkan([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistMasterIkan(0, 10)
    }, [getlistMasterIkan])

    const handleChangePage = (page) => {
        getlistMasterIkan(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listMasterIkanTrader(localStorage.getItem('kodeTrader') !== null ? localStorage.getItem('kodeTrader') : null, null, page - 1, size)
        setListMasterIkan(_res.data.data)
        setSize(size)
    }

    const handleClickTambahIkan = () => {
        localStorage.removeItem("dataIkanStorage")
        navigate('/master/ikan-add-edit')
    }

    const handleClickEditIkan = (data) => {
        localStorage.removeItem("dataIkanStorage")
        localStorage.setItem("dataIkanStorage", JSON.stringify(data, null, 2))
        navigate('/master/ikan-add-edit')
    }

    const [valueSearch, setValueSearch] = useState(null)
    const [loadingSearch, setLoadingSearch] = useState(false)

    const onChangeSearch = e => {
        setValueSearch(e.target.value)
    }

    const handleClickReset = () => {
        setValueSearch('')
        getlistMasterIkan(0, 10)
    }

    const handleClickCari = async () => {
        setLoadingSearch(true)
        const _res = await masterService.listMasterIkanTrader(localStorage.getItem('kodeTrader') !== null ? localStorage.getItem('kodeTrader') : null, valueSearch, 0, size)
        setListMasterIkan(_res.data.data)
        setTotalData(_res.data.totalData)
        setLoadingSearch(false)
    }


    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-6">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Dagang</Form.Label>
                                            <Col sm="6">
                                                <Form.Control type="searchNib" placeholder="Nama Dagang" className="form-control-sm" value={valueSearch} onChange={onChangeSearch} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari()} disabled={loadingSearch}>{loadingSearch && <Spinner />}Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Ikan</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            {
                                localStorage.getItem("kodeTrader") !== null &&
                                <Button type="button" variant="primary" size="sm" onClick={() => handleClickTambahIkan()} ><FaPlus /> Tambah</Button>
                            }
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listMasterIkan}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default MasterIkan;
